function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgByKotlin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.9594,
    y1: -13.0143,
    x2: 44.3068,
    y2: 15.3332,
    gradientTransform: "matrix(1 0 0 -1 0 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09677,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    style: {
      stopColor: "#238AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    style: {
      stopColor: "#557BDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#7472E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#806EE3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    style: {
      fill: "url(#XMLID_3_)"
    },
    points: "0,60 30.1,29.9 60,60  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2092,
    y1: 48.9409,
    x2: 20.6734,
    y2: 65.405,
    gradientTransform: "matrix(1 0 0 -1 0 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1183,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4178,
    style: {
      stopColor: "#3C83DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6962,
    style: {
      stopColor: "#6D74E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#806EE3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "0,0 30.1,0 0,32.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.1017,
    y1: 5.8362,
    x2: 45.7315,
    y2: 61.6694,
    gradientTransform: "matrix(1 0 0 -1 0 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#D0609A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    style: {
      stopColor: "#E1725C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    style: {
      stopColor: "#EE7E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#F58613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#F88909"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    points: "30.1,0 0,31.7 0,60 30.1,29.9 60,0  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgByKotlin);
export default __webpack_public_path__ + "static/media/svg_by_kotlin.d5f79188.svg";
export { ForwardRef as ReactComponent };